import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

let onUnauthorized = null;
export const setUnauthorizedHandler = (cb) => {
  onUnauthorized = cb;
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || "";
    // Don't fire the 401-handler for the bootstrap /me check — that just means "not logged in"
    if (err?.response?.status === 401 && onUnauthorized && !url.endsWith("/auth/me")) {
      onUnauthorized();
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export default api;
